<script lang="ts">
    import Fa from 'svelte-fa'
    import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons'
    import Popover from '../../_common/popover.svelte'
    import { createEventDispatcher, onMount } from 'svelte'
    import { PaymentMethod } from '../../../modules/posApi/payment-methods/payment-methods'
    import Payments from './payments.svelte'
    const dispatch = createEventDispatcher()

    export let paymentMethod: PaymentMethod = null
    export let disabled: boolean = false
    export let small = false
    export let label = ''
    export let all: boolean = false
    export let allowAdd: boolean = true

    let query = ''
    let paymentMethods: PaymentMethod[] = []

    let delay = null
    async function search(query) {
        if (delay) clearInterval(delay)
        delay = setTimeout(async () => {
            paymentMethods = await window.api.pos.paymentMethods.getAll({ query, pageSize: 100 })
            if (paymentMethods.length === 0) dropHelper = 'Não encontrado.'
        }, 500)
    }
    async function getFirst100() {
        paymentMethods = await window.api.pos.paymentMethods.getAll({ pageSize: 100 })
    }

    function select(index) {
        paymentMethod = paymentMethods[index]
        query = ''
        paymentMethods = []
        dispatch('change', paymentMethod)
    }

    async function loadService(paymentMethodId) {
        if (paymentMethodId) {
            paymentMethod = await window.api.pos.paymentMethods.getOne(paymentMethodId)
            _showDrop = false
        }
    }

    function friendlyName(p) {
        return p?.label || ''
    }

    function clear() {
        paymentMethod = null
        dispatch('change', null)
        _showDrop = false
    }

    let showForm = false
    function newService() {
        paymentMethod = new PaymentMethod()
        showForm = true
    }

    function editService() {
        showForm = true
    }

    async function hideForm(event) {
        showForm = false
        await getFirst100()
        if (event.detail?.paymentMethodId) {
            paymentMethod = event.detail
            dispatch('change', paymentMethod)
        } else {
            if (paymentMethod?.paymentMethodId) {
                paymentMethod = paymentMethods.find((el) => el.paymentMethodId === paymentMethod.paymentMethodId)
                dispatch('change', paymentMethod)
            }
        }
    }

    let _showDrop = false
    let dropHelper = 'Digite ao menos 3 caracteres para pesquisar...'
    function showDrop(event) {
        _showDrop = true
    }

    function hideDrop(event) {
        setTimeout(() => {
            _showDrop = false
        }, 300)
    }

    onMount(async () => {
        await getFirst100()
    })

    $: {
        if (paymentMethod?.paymentMethodId && !paymentMethod?.createdAt) loadService(paymentMethod.paymentMethodId)
        search(query)
    }
</script>

{#if showForm}
    <Popover on:close={hideForm} title="Meio de Pagamento" height="420px" width="970px">
        <Payments paymentMethodId={paymentMethod.paymentMethodId} form={true} on:close={hideForm}></Payments>
    </Popover>
{/if}
<div class="query">
    <div class="input-group custom-control" class:input-group-sm={small === true}>
        {#if label}
            <div class="input-group-text">{label}</div>
        {/if}
        {#if paymentMethod && paymentMethod.paymentMethodId}
            <input class="form-control" class:form-control-sm={small === true} disabled value={friendlyName(paymentMethod)} type="text" />
            <!-- <button on:click={editService} class="btn btn-secondary"><Fa icon={faEdit} /></button> -->
            {#if !disabled}
                <button class="btn btn-secondary" class:form-control-sm={small === true} on:click={clear}><Fa icon={faTimes} /></button>
            {/if}
        {:else}
            <input
                class="form-control btn-end select-icon"
                class:form-control-sm={small === true}
                type="text"
                bind:value={query}
                on:focus={showDrop}
                on:blur={hideDrop}
                placeholder={all ? 'Todos' : ''}
            />
            {#if allowAdd}
                <button on:click={newService} class="btn btn-secondary"><Fa icon={faPlus} /></button>
            {/if}
        {/if}
    </div>

    {#if _showDrop}
        <div class="list scroll-dark">
            {#if paymentMethods.length === 0}
                <div class="list-helper p-2 text-muted">{dropHelper}</div>
            {:else}
                {#each paymentMethods as p, index}
                    <button
                        on:click={() => {
                            select(index)
                        }}>{friendlyName(p)}</button
                    >
                {/each}
            {/if}
        </div>
    {/if}
</div>

<style>
    .list-helper {
        color: #333;
        background-color: #eee;
    }
    .query {
        position: relative;
        flex-grow: 1;
        width: 100%;
    }
    .list {
        display: flex;
        flex-direction: column;
        box-shadow: 4px 3px 6px #111;
        position: absolute;
        flex-grow: 1;
        z-index: 5;
        width: 100%;
        overflow-y: auto;
        max-height: 200px;
    }
    .list button {
        flex-grow: 1;
        padding: 8px;
        text-align: left;
    }
    .list button:hover {
        background-color: #ddd;
    }
</style>
